<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('system.text_130', [$t('dictionary.endpoint')])}}</div>
    <div slot="body">
      <a-alert type="warning" :message="$t('system.text_179')" class="mb-2" />
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item :label="$t('system.text_101')">
          <a-input v-decorator="decorators.name" />
        </a-form-item>
        <a-form-item label="URL">
          <a-input v-decorator="decorators.url" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import Cookies from 'js-cookie'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'EndpointCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        name: [
          'name',
          {
            rules: [
              {
                required: true,
                message: this.$t('system.text_170'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        url: [
          'url',
          {
            validateFirst: true,
            rules: [
              {
                required: true,
                message: this.$t('system.text_175'),
                transform: val => val && R.trim(val),
              },
              {
                validator: this.$validate('url'),
              },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 22,
        },
        labelCol: {
          span: 2,
        },
      },
    }
  },
  destroyed () {
    this.em = null
  },
  created () {
    this.em = new this.$Manager('endpoints', 'v1')
    this.sm = new this.$Manager('services', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const servicesResponse = await this.sm.list()
        const services = servicesResponse.data.data || []
        const external = services.find(item => item.name === 'external-service')
        if (!external) {
          this.$message.error(this.$t('system.text_180'))
          throw new Error(this.$t('system.text_180'))
        }
        await this.em.create({
          data: {
            ...values,
            service: 'external-service',
            region_id: Cookies.get('region'),
            interface: 'console',
            enabled: true,
          },
        })
        this.loading = false
        this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
